







import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class SpanNullable extends Vue {
    @Prop()
    private content: unknown | null
}
